export * from './NewsThumbnail';
